"use client";
import { jsx } from "react/jsx-runtime";
import { useSvg } from "../../../hooks/useSvg.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { rem, ActionIcon } from "@mantine/core";
import { forwardRef } from "react";
import { resolvePadding, resolveRadius, resolveIconColor, resolveSize } from "./Icon.helpers.js";
import { I as IconList } from "./IconList.js";
import '../../../assets/Icon.css';const root = "_root_1ytv4_2";
const loader = "_loader_1ytv4_38";
const IconStyles = {
  root,
  loader
};
const _Icon = forwardRef((props, ref) => {
  const {
    onClick,
    name,
    variant = "transparent",
    href,
    target,
    stroke = 1.5,
    size = "md",
    className,
    color,
    loading,
    mod,
    style,
    ariaLabel,
    radius,
    p,
    ...rest
  } = props;
  const Svg = useSvg(`Icon${name}`, IconList, size, stroke);
  const clickable = !!(href || onClick);
  const resolvedPadding = p ? resolvePadding(p) : rem("8px");
  const resolvedSize = `calc(${resolveSize(size)} + ${variant !== "transparent" ? `${resolvedPadding}* 2` : "0px"})`;
  const parsedColor = resolveIconColor(color);
  const handleClick = (e) => {
    onClick == null ? void 0 : onClick(e);
  };
  return /* @__PURE__ */ jsx(
    ActionIcon,
    {
      ...rest,
      component: href ? "a" : "span",
      size: resolvedSize,
      onClick: handleClick,
      variant,
      className,
      classNames: IconStyles,
      href,
      ref,
      target: href && target,
      mod: { loading, clickable, ...mod },
      loading,
      style: {
        ...style,
        "--passed-icon-color": parsedColor,
        "--passed-radius": resolveRadius(radius),
        "--passed-padding": resolvedPadding
      },
      "aria-label": ariaLabel,
      children: Svg
    }
  );
});
_Icon.displayName = "Icon";
const Icon = sharedHandler(_Icon);
Icon.displayName = _Icon.displayName;
export {
  IconStyles as I,
  Icon as default
};
